export type HighlightType = 'success' | 'error'

export interface HighlightEntry {
  type: HighlightType
  addedAt: number
}

export interface UIState {
  highlightedRows: Map<string, HighlightEntry>
  selectedOfficial: any | null
  isOfficialModalOpen: boolean
  isAddPlayerSheetOpen: boolean
}

export enum UIActionType {
  ADD_HIGHLIGHTED_ROW = 'ADD_HIGHLIGHTED_ROW',
  CLEAR_EXPIRED_HIGHLIGHTS = 'CLEAR_EXPIRED_HIGHLIGHTS',
  SET_SELECTED_OFFICIAL = 'SET_SELECTED_OFFICIAL',
  SET_OFFICIAL_MODAL_OPEN = 'SET_OFFICIAL_MODAL_OPEN',
  SET_ADD_PLAYER_SHEET_OPEN = 'SET_ADD_PLAYER_SHEET_OPEN',
}

export type UIAction =
  | {
      type: UIActionType.ADD_HIGHLIGHTED_ROW
      payload: { id: string; highlightType: HighlightType; addedAt: number }
    }
  | { type: UIActionType.CLEAR_EXPIRED_HIGHLIGHTS; payload: number }
  | { type: UIActionType.SET_SELECTED_OFFICIAL; payload: any | null }
  | { type: UIActionType.SET_OFFICIAL_MODAL_OPEN; payload: boolean }
  | { type: UIActionType.SET_ADD_PLAYER_SHEET_OPEN; payload: boolean }

export interface UIContextValue extends UIState {
  addHighlightedRow: (id: string, type?: HighlightType) => void
  setSelectedOfficial: (official: any | null) => void
  setOfficialModalOpen: (open: boolean) => void
  setAddPlayerSheetOpen: (open: boolean) => void
}

export const HIGHLIGHT_DURATION_MS = 5000
export const CLEANUP_INTERVAL_MS = 1000
